<template>
  <div>
    <div class="previsioni">
      <div class="consiglio">

        <div
          class="testoConsiglio"
          :class="{
            [tipoConsiglio]: tipoConsiglio,
            [effectConsiglio]: effectConsiglio,
          }"
        >
          {{ consiglio }}
        </div>
        <div v-if="actionConsiglio" class="actionConsiglio ml-1">
          <v-btn
            class="secondary--text navy darken-2 mr-1 py-3"
            depressed
            x-small
            :class="(glow)? 'glow' : ''"
            @click="actionConsiglio"
          >
            <v-icon small v-show="actionConsiglioIcon">{{
              actionConsiglioIcon
            }}</v-icon>
            {{ actionConsiglioText }}</v-btn
          >
        </div>
      </div>
    </div>
    <!-- https://stackoverflow.com/questions/61444870/maximum-call-stack-size-exceeded-vuetify -->
    <v-dialog
      v-model="dialogTogliereCrediti"
      max-width="500"
      :retain-focus="false"
      hide-overlay
    >
      <v-card class="navy pa-4">
        <div
          class="navy white--text pt-2 px-2 d-flex align-center font-hemi-head"
        >
          <v-icon class="white--text" left>bolt</v-icon
          ><span style="font-size: 18px">Correzione veloce</span>
          <v-spacer></v-spacer>
          <v-btn depressed icon @click="dialogTogliereCrediti = false">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-list
          :class="{ 'nice-scroll': !is_mobile }"
          class="recycle-scroller py-4"
        >
          <div v-for="(ruoloData, ruolo_abc) in planConsiglio" :key="ruolo_abc">
            <div
              v-for="(slotData, slot, i) in ruoloData"
              :key="ruolo_abc + '_' + slot"
            >
              <asta-slot
                :ruolo_abc="ruolo_abc"
                :iSlot="slot"
                :i="i"
                readonly
                :append="planConsiglio[ruolo_abc][slot].crediti"
              ></asta-slot>
            </div>
          </div>
        </v-list>
        <v-divider></v-divider>
        <v-card-actions class="justify-center pt-4">
          <v-btn rounded class="secondary" @click="correzioneVeloce">Ok</v-btn>
          <v-btn
            rounded
            class="secondary--text"
            outlined
            @click="dialogTogliereCrediti = false"
            >No, correggo a mano</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import db from "../js/db";

import mixins from "../js/mixins";
import toast from "../js/toast";
import Constants from "../js/constants";
import { ErrorAdjustPlan } from "../js/errors";
import Vuex from "vuex";
import AstaSlot from "./AstaSlot";

export default {
  name: "asta-consiglio",
  components: { AstaSlot },
  mixins: [mixins, toast],
  data() {
    return {
      tipoConsiglio: "neutro",
      effectConsiglio: "",
      actionConsiglio: null,
      actionConsiglioText: "",
      actionConsiglioIcon: "",
      glow: false,
      planConsiglio: {},
      numNoCrediti: 0,
      calciatoreDaAssociare: null,
      delta: null,
      dialogTogliereCrediti: false,
    };
  },
  props: {},
  created() {},
  mounted() {
    console.log("--> AstaConsiglio mounted.");
  },
  destroyed() {
    console.log("<-- AstaConsiglio destroyed.");
  },
  methods: {
    showRoseLega() {
      db.emit("showDialogRoseLega");
    },
    promptDialogPlanSettings() {
      db.emit("DialogPlanSettings");
    },
    promptDialogAssociaSlot() {
      if (this.calciatoreDaAssociare) {
        db.emit("DialogAssociaSlot", this.calciatoreDaAssociare);
      }
    },
    correzioneVeloce() {
      // Rules may have changed while the preview was open.
      const plan = {};
      for (const ruolo in this.planConsiglio) {
        for (const slot in this.planConsiglio[ruolo]) {
          const current = (this.myPlan[ruolo] || {})[slot];
          if (current && !current.associato) {
            if (!plan[ruolo]) plan[ruolo] = {};
            plan[ruolo][slot] = this.planConsiglio[ruolo][slot];
          }
        }
      }
      db.updatePlan(plan);
      this.dialogTogliereCrediti = false;
    },
    togliCreditiPreview() {
      let plan = this.getPlanNonAssociati();
      this.iterator = 0;
      try {
        this.adjustPlan(plan, this.delta);
        this.onlyNew(plan);
        // console.log("planNew", plan);
        this.planConsiglio = plan;
        this.dialogTogliereCrediti = true;
      } catch (error) {
        if (error instanceof ErrorAdjustPlan) {
          Swal.fire({
            icon: "error",
            text: error.message,
          });
        } else {
          throw error;
        }
      }
    },
    aumentaCreditiPreview() {
      // prendi il primo slot libero in ciascun ruolo, portiere escluso
      const firstSlotsLiberi = this.getFirstSlotsLiberi();
      const delta = -this.delta;
      const nSlotsLiberi = firstSlotsLiberi.length;
      if (nSlotsLiberi > 0) {
        const split = this.splitNumber(delta, nSlotsLiberi);
        let plan = {};
        _.each(firstSlotsLiberi, (item, i) => {
          const { ruolo_abc, slot } = item;
          const creditiPrev = this.myPlan[ruolo_abc][slot].crediti;
          if (split[i] > 0) {
            plan[ruolo_abc] = {
              ...plan[ruolo_abc],
              [slot]: { crediti: creditiPrev + split[i] },
            };
          }
        });
        this.planConsiglio = plan;
        this.dialogTogliereCrediti = true;
      }
    },

    getFirstSlotsLiberi() {
      let firstSlotsLiberi = [];
      for (const ruolo_abc in this.myPlan) {
        if (ruolo_abc != "P") {
          for (const slot in this.myPlan[ruolo_abc]) {
            const associato = this.myPlan[ruolo_abc][slot]["associato"];
            if (
              !this.isAssociato(associato) &&
              (!this.isMassimo || Number(this.myPlan[ruolo_abc][slot].crediti) > 0)
            ) {
              firstSlotsLiberi.push({
                ruolo_abc: ruolo_abc,
                slot: slot,
              });
              // goto next ruolo
              break;
            }
          }
        }
      }
      return firstSlotsLiberi;
    },

    sumCrediti(plan) {
      let output = 0;
      for (const ruolo_abc in plan) {
        for (const slot in plan[ruolo_abc]) {
          const crediti = plan[ruolo_abc][slot].crediti;
          output = output + crediti;
        }
      }
      return output;
    },

    onlyNew(plan) {
      for (const ruolo_abc in plan) {
        for (const slot in plan[ruolo_abc]) {
          if (!plan[ruolo_abc][slot].new) {
            delete plan[ruolo_abc][slot];
          }
        }
      }
    },

    adjustPlan(plan, delta) {
      this.iterator++;

      const sum = this.sumCrediti(plan);
      const target = sum - delta;

      // console.log("initial plan", plan);
      // console.log("initial", sum);
      // console.log("target", target);
      // console.log("delta", delta);

      const switchedPlan = {};
      for (const ruolo_abc in plan) {
        for (const slot in plan[ruolo_abc]) {
          if (!switchedPlan[slot]) {
            switchedPlan[slot] = {};
          }
          switchedPlan[slot][ruolo_abc] = {
            crediti: plan[ruolo_abc][slot].crediti,
          };
        }
      }

      // console.log("switchedPlan", switchedPlan);

      for (const slot in switchedPlan) {
        for (const ruolo_abc in switchedPlan[slot]) {
          const crediti = plan[ruolo_abc][slot].crediti;
          if (crediti > 1) {
            plan[ruolo_abc][slot].crediti = crediti - 1;
            plan[ruolo_abc][slot].new = 1;
            // console.log(
            //   ruolo_abc + " - " + slot,
            //   plan[ruolo_abc][slot].crediti
            // );
            // console.log("sumCrediti", this.sumCrediti(plan));
            if (this.sumCrediti(plan) == target) {
              // console.log("return");
              return;
            }
          }
        }
      }

      const newSum = this.sumCrediti(plan);
      const newDelta = newSum - target;

      // console.log("adjustedPlan", plan);
      // console.log("newSum", newSum);
      // console.log("newDelta", newDelta);

      if (newDelta > 0) {
        if (this.iterator < 5) {
          this.adjustPlan(plan, newDelta);
        } else {
          throw new ErrorAdjustPlan(
            "Ci sono un po' troppi crediti in eccesso. In casi come questi meglio che sia tu a redistribuirli manualmente"
          );
        }
      } else if (newDelta < 0) {
        throw new ErrorAdjustPlan(
          "Errore inatteso. Puoi comunque distribuire manualmente i crediti"
        );
      } else {
        return;
      }
    },

    isAssociato(associato) {
      return (
        associato != "" &&
        this.my_squadra.calciatori &&
        this.my_squadra.calciatori[associato]
      );
    },
    getPlanNonAssociati() {
      let output = {};
      for (const ruolo_abc in this.myPlan) {
        for (const slot in this.myPlan[ruolo_abc]) {
          const associato = this.myPlan[ruolo_abc][slot]["associato"];
          if (
            !this.isAssociato(associato) &&
            (!this.isMassimo || Number(this.myPlan[ruolo_abc][slot].crediti) > 0)
          ) {
            const crediti = this.myPlan[ruolo_abc][slot].crediti;
            output[ruolo_abc] = _.assign({}, output[ruolo_abc], {
              [slot]: { crediti: crediti },
            });
          }
        }
      }
      return output;
    },
    splitNumber(number, count) {
      const integers = [];
      let remaining = number;

      for (let i = 0; i < count - 1; i++) {
        const value = Math.round(remaining / (count - i));
        integers.push(value);
        remaining -= value;
      }

      integers.push(remaining); // Add the last remaining value

      return integers;
    },
  },

  computed: {
    isMassimo() {
      return this.asta_info.lega.nRuoli.op === "<=";
    },
    acquistiOltreLimite() {
      const regole = this.asta_info.lega.nRuoli;
      if (regole.op !== "=" && regole.op !== "<=") return false;
      return Object.values(Constants.RUOLI_NEW).some(ruolo => {
        const count = Object.keys(this.my_squadra.calciatori || {}).filter(id =>
          this.calciatori[id] && Number(this.calciatori[id].ID_Ruolo) === ruolo.ruolo_id
        ).length;
        return count > Number(regole[ruolo.n]);
      });
    },

    previsioneSpesa() {
      // Actual spending includes retained and not-yet-associated purchases.
      let output = Object.values(this.my_squadra.calciatori || {}).reduce(
        (total, calciatore) => total + (Number(calciatore.p) || 0), 0
      );
      let numNoCrediti = 0;
      for (const ruolo_abc in this.myPlan) {
        for (const i in this.myPlan[ruolo_abc]) {
          const associato = this.myPlan[ruolo_abc][i]["associato"];
          if (!this.isAssociato(associato)) {
            const crediti = Number(this.myPlan[ruolo_abc][i]["crediti"]) || 0;
            output = output + crediti;
            if (!crediti && !this.isMassimo) {
              numNoCrediti++;
            }
          }
        }
      }
      this.numNoCrediti = numNoCrediti;
      return output;
    },
    calciatoriRosaNonAssociati() {
      return _.difference(_.keys(this.my_squadra.calciatori), this.associati);
    },
    consiglio() {
      // Calcola anche gli slot senza crediti prima di scegliere il consiglio.
      const previsioneSpesa = this.previsioneSpesa;
      this.actionConsiglio = null;
      this.actionConsiglioText = "";
      this.actionConsiglioIcon = "";
      this.glow = false

      if (this.acquistiOltreLimite) {
        this.tipoConsiglio = "negativo";
        this.effectConsiglio = "";
        this.actionConsiglio = this.showRoseLega;
        this.actionConsiglioText = "Rose";
        return "Acquisti oltre il limite del ruolo: verifica con l’amministratore";
      }

      // With a maximum roster, empty slots are optional. On the very first
      // setup, however, offer the automatic distribution before treating
      // zero-credit slots as the user's deliberate choice.
      if (this.isMassimo && !this.hasPlanSalvato) {
        this.tipoConsiglio = "negativo";
        this.effectConsiglio = "zoom-in-zoom-out";
        this.actionConsiglio = this.promptDialogPlanSettings;
        this.actionConsiglioText = "Distribuisci";
        this.glow = true;
        return "Crediti non pianificati";
      }

      // controlla se hai impostato tutti
      if (this.numNoCrediti > 0) {
        this.tipoConsiglio = "negativo";
        this.effectConsiglio = "zoom-in-zoom-out";
        this.actionConsiglio = this.promptDialogPlanSettings;
        this.actionConsiglioText = "Distribuisci";
        this.glow = true;
        return "Crediti non pianificati";
      }

      const textCheck = this.checkIfSlotsAreEnough;
      if (textCheck) {
        this.tipoConsiglio = "negativo";
        this.effectConsiglio = "zoom-in-zoom-out";
        this.actionConsiglio = this.promptDialogPlanSettings;
        this.actionConsiglioText = "Correggi";
        return textCheck;
      }

      // 3) controlla se ci sono calciatori in rosa non inseriti
      if (this.calciatoriRosaNonAssociati.length > 0) {
        const calciatore_id = this.calciatoriRosaNonAssociati[0];
        const nomeCalciatore = this.calciatori[calciatore_id].calciatore;
        this.tipoConsiglio = "negativo";
        this.effectConsiglio = "zoom-in-zoom-out";
        this.calciatoreDaAssociare = calciatore_id;
        this.actionConsiglio = this.promptDialogAssociaSlot;
        this.actionConsiglioText = "Correggi";
        return nomeCalciatore + " in rosa ma non inserito";
      }

      this.delta = previsioneSpesa - this.creditiLega;
      const delta = this.delta;
      if (delta < 0) {
        if (this.isMassimo && this.getFirstSlotsLiberi().length === 0) {
          this.tipoConsiglio = "positivo";
          return -delta + (delta == -1 ? " credito non impegnato" : " crediti non impegnati");
        }
        this.tipoConsiglio = "positivo";
        this.effectConsiglio = "zoom-in-zoom-out";
        this.actionConsiglio = this.aumentaCreditiPreview;
        this.actionConsiglioIcon = "bolt";
        return (
          -delta + (delta == -1 ? " credito" : " crediti") +
          (this.isMassimo ? " da redistribuire" : " da pianificare")
        );
      } else if (delta > 0) {
        this.tipoConsiglio = "negativo";
        this.effectConsiglio = "zoom-in-zoom-out";
        this.actionConsiglio = this.togliCreditiPreview;
        this.actionConsiglioIcon = "bolt";
        return (
          "Attenzione, " +
          delta +
          (delta == 1 ? " credito" : " crediti") +
          " di troppo!"
        );
      } else {
        this.tipoConsiglio = "neutro";
        return "Bene così";
      }
    },
    creditiLega() {
      return this.asta_info.lega.crediti;
    },
    checkIfSlotsAreEnough() {
      for (const ruolo_abc in this.myPlan) {
        const ruolo_id = Constants.RUOLO[ruolo_abc];
        if (
          _.size(this.myPlan[ruolo_abc]) +
            Object.values(this.myPlanFuoriLimite[ruolo_abc] || {}).filter(slot => slot.associato).length <
          this.acquistiPerRuolo(ruolo_id, this.my_squadra.id)
        ) {
          return (
            "Hai pianificato troppi pochi " +
            Constants.RUOLI_NEW[ruolo_id].plurale.toLowerCase()
          );
        }
      }
      return null;
    },
    ...Vuex.mapGetters(["myPlan", "myPlanFuoriLimite", "associati", "hasPlanSalvato"]),
  },

  watch: {
    effectConsiglio: {
      handler(val) {
        if (val) {
          setTimeout(() => {
            this.effectConsiglio = "";
          }, 3000);
        }
      },
      immediate: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.previsioni {
  color: white;
  text-align: center;
  min-height: 40px;
  padding-top: 10px;
  .consiglio {
    display: inline-flex;
    align-items: center;

    .testoConsiglio {
      padding: 2px 5px;
      font-weight: bold;
      line-height: 1;

      &.positivo {
        color: var(--v-secondary-base);
      }
      &.negativo {
        color: var(--v-error-lighten1);
      }
      &.neutro {
        color: var(--v-navy-lighten3);
      }
    }
    .actionConsiglio .v-btn {
      font-size: 9px;
      box-shadow: 0 0 0 1px var(--v-secondary-base) inset;
      &.glow{
        box-shadow: 0 0 0 1px var(--v-secondary-base) inset, 0px 0px 12px 2px rgba(246, 189, 0, 0.8);
      }
    }
  }
}
</style>
